import { Phone, Send, MessageCircle } from "lucide-react";
import { TOUR } from "../constants/testIds";

/**
 * Managers with direct-contact deep links.
 * telegram: `t.me/<username>` OR `t.me/+<phone>` fallback.
 * whatsapp: `wa.me/<phone-digits>`.
 */
const MANAGERS = [
  {
    id: "natalya",
    testId: TOUR.contactNatalya,
    name: "Наталья",
    role: "Ведущий агент",
    phone: "+7 922 383-19-19",
    phoneDigits: "79223831919",
    telegram: "https://t.me/kudapoedemNatasha",
    accent: "teal",
  },
  {
    id: "inna",
    testId: TOUR.contactInna,
    name: "Инна",
    role: "Менеджер по турам",
    phone: "+7 912 981-12-22",
    phoneDigits: "79129811222",
    telegram: "https://t.me/+79129811222",
    accent: "coral",
  },
  {
    id: "yuliya",
    testId: TOUR.contactYuliya,
    name: "Юлия",
    role: "Менеджер по турам",
    phone: "+7 982 485-97-50",
    phoneDigits: "79824859750",
    telegram: "https://t.me/yuliayulia001",
    accent: "teal",
  },
];

const ActionBtn = ({ href, icon: Icon, label, className = "", testId, external }) => (
  <a
    href={href}
    data-testid={testId}
    target={external ? "_blank" : undefined}
    rel={external ? "noopener noreferrer" : undefined}
    className={`inline-flex items-center justify-center gap-1.5 h-10 px-3 rounded-full text-xs font-semibold transition-all ${className}`}
  >
    <Icon className="w-3.5 h-3.5" />
    {label}
  </a>
);

export const ManagerCards = () => (
  <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
    {MANAGERS.map((m) => (
      <div
        key={m.id}
        data-testid={m.testId}
        className="bg-white rounded-2xl p-6 border border-[#F0DFC1] hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 flex flex-col"
      >
        <div className="flex items-start gap-4">
          <div
            className={`w-14 h-14 rounded-full flex items-center justify-center shrink-0 ${
              m.accent === "coral" ? "bg-coral/15 text-coral" : "bg-teal/15 text-teal"
            }`}
          >
            <Phone className="w-6 h-6" />
          </div>
          <div className="min-w-0">
            <div className="text-xs uppercase tracking-[0.18em] text-teal mb-1">{m.role}</div>
            <div className="font-display text-2xl text-[#063B4E] leading-tight">{m.name}</div>
            <a
              href={`tel:+${m.phoneDigits}`}
              className="text-base font-semibold text-[#1B2A3B] mt-1 hover:text-coral transition-colors block"
            >
              {m.phone}
            </a>
          </div>
        </div>

        <div className="mt-5 pt-5 border-t border-[#F0DFC1] flex flex-wrap gap-2">
          <ActionBtn
            href={`tel:+${m.phoneDigits}`}
            icon={Phone}
            label="Позвонить"
            testId={`${m.testId}-call`}
            className="bg-teal text-white hover:bg-[#0a616a] flex-1 min-w-[110px]"
          />
          <ActionBtn
            href={m.telegram}
            icon={Send}
            label="Telegram"
            testId={`${m.testId}-tg`}
            external
            className="bg-[#229ED9] text-white hover:bg-[#1a86ba] flex-1 min-w-[100px]"
          />
          <ActionBtn
            href={`https://wa.me/${m.phoneDigits}`}
            icon={MessageCircle}
            label="WhatsApp"
            testId={`${m.testId}-wa`}
            external
            className="bg-[#25D366] text-white hover:bg-[#1eb655] flex-1 min-w-[100px]"
          />
        </div>
      </div>
    ))}
  </div>
);
